import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import * as XLSX from "xlsx";
// Antd Components
import { Modal, message, Upload, Button, Radio, Alert, List } from "antd";
import {
  UploadOutlined,
  SendOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import instance from "@/store/actions/instance";

// Actions

class InventoryExcelUploader extends Component {
  beforeUpload = (file) => {
    const isExcel =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (!isExcel) {
      message.error("You can only upload Excel file!");
    }

    return isExcel;
  };
  state = {
    rawProducts: [],
    products: [],
    productIdentifier: "id",

    isUploading: false,
    isSubmitting: false,
    importSummary: null,
    importErrors: [],
  };
  handleExcelUpload = (file) => {
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);

    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const wb = XLSX.read(data, { type: "array" });

      const sheet = wb.Sheets[wb.SheetNames[0]];

      const rawProducts = XLSX.utils.sheet_to_json(sheet, {
        defval: undefined,
      });

      this.validateProducts(rawProducts);
    };
  };
  validateProducts = (rawProducts) => {
    const { productIdentifier } = this.state;
    const { type } = this.props;

    const cleanedProducts = [];
    const errors = [];

    rawProducts.forEach((row, index) => {
      const excelRow = index + 2;

      const isEmptyRow = Object.values(row).every(
        (v) => v === null || v === "" || v === undefined,
      );

      if (isEmptyRow) return;

      const identifier = row[productIdentifier];

      if (!identifier) {
        errors.push({
          row: excelRow,
          message: `Missing ${productIdentifier}`,
        });
        return;
      }

      const rawQuantity = row["quantity"];
      if (
        rawQuantity === null ||
        rawQuantity === undefined ||
        String(rawQuantity).trim() === ""
      ) {
        return;
      }

      const qty = Number(rawQuantity);
      if (!Number.isFinite(qty) || qty < 0) {
        errors.push({
          row: excelRow,
          message: "Invalid quantity (must be a non-negative number)",
        });
        return;
      }

      let cost = row["cost"];
      if (type == "purchase_order") {
        cost = Number(cost);
        if (!Number.isFinite(cost) || cost < 0) {
          errors.push({
            row: excelRow,
            message: "Invalid cost (must be a non-negative number)",
          });
          return;
        }
      }

      cleanedProducts.push({
        ...row,
        quantity: qty,
        ...(type == "purchase_order" ? { cost } : {}),
        counted_quantity: qty,
        unit: row.unit?.trim(),
        _identifier: identifier,
      });
    });

    this.setState({
      rawProducts,
      products: cleanedProducts,
      importErrors: errors,
      importSummary: {
        total: rawProducts.length,
        valid: cleanedProducts.length,
        errors: errors.length,
      },
    });
  };

  handleSubmit = async () => {
    const { t, selectedOrder, type } = this.props;
    const { productIdentifier, products } = this.state;
    if (this.state.isSubmitting) return;

    this.setState({ isSubmitting: true });
    let importSucceeded = false;
    let importedData = null;
    try {
      const res = await instance.post(`/update_${type}_excel/`, {
        orderId: selectedOrder.id,
        products: products,
        productIdentifier: productIdentifier,
      });

      importSucceeded = true;
      importedData = res.data;
      message.success(t("Updated successfully"));
    } catch (err) {
      if (err.response?.data?.errors) {
        this.setState({ importErrors: err.response?.data?.errors });
        return;
      }
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    } finally {
      this.setState({ isSubmitting: false });
    }
    if (importSucceeded) {
      this.props.onClose(true, importedData);
    }
  };
  downloadTemplate = async () => {
    const { t, selectedOrder, type } = this.props;

    try {
      this.setState({ isUploading: true });

      let wb = XLSX.utils.book_new();
      const res = await instance.post(`generate_excel_template_${type}/`, {
        supplier_id: selectedOrder?.supplier_id,
      });
      wb.SheetNames.push("products");
      let ws_data = res.data;
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["products"] = ws;
      XLSX.writeFile(wb, `${type}_template.xlsx`);
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ isUploading: false });
  };

  render() {
    const { visible, t, config } = this.props;
    const {
      productIdentifier,
      isUploading,
      isSubmitting,
      importErrors,
      importSummary,
    } = this.state;

    return (
      <Modal
        style={{ top: 20 }}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {t("Import Via Excel")}
          </div>
        }
        visible={visible}
        onCancel={() => this.props.onClose()}
        footer={null}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          paddingBottom: 10,
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        <div className="px-2 my-3">
          <div className="mt-2">
            <ol>
              <li>
                <Button
                  className="p-0"
                  type="link"
                  onClick={this.downloadTemplate}
                  size="small"
                  loading={isUploading}
                >
                  {t("Download Product's Template")}
                </Button>

                <br />
                <br />
              </li>

              <li>
                {t("Upload The File")}

                <Upload
                  className={"mx-3"}
                  name="file"
                  beforeUpload={this.beforeUpload}
                  multiple={false}
                  showUploadList={false}
                  customRequest={({ file }) => {
                    this.handleExcelUpload(file);
                  }}
                >
                  <Button>
                    <UploadOutlined type="upload" /> {t("Pick a file")}
                  </Button>
                  {this.state.products.length > 0 && (
                    <CheckCircleFilled
                      style={{
                        fontSize: "20px",
                        color: "green",
                        left: (config.language === "arabic" && -10) || 10,
                      }}
                    />
                  )}
                </Upload>
                {/* ✅ UI SUMMARY */}
                {importSummary && (
                  <div style={{ marginTop: 15 }}>
                    <Alert
                      type={importSummary.errors > 0 ? "warning" : "success"}
                      showIcon
                      message={t("Import Summary")}
                      description={
                        <div>
                          <div>
                            {t("Total Products:")} <b>{importSummary.total}</b>
                          </div>
                          <div>
                            {t("Valid Products:")} <b>{importSummary.valid}</b>
                          </div>
                          <div>
                            {t("Errors:")} <b>{importSummary.errors}</b>
                          </div>
                        </div>
                      }
                    />
                  </div>
                )}
                {/* ❌ ERROR LIST */}
                {importErrors.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <Alert
                      type="error"
                      message={t("Errors found in file")}
                      description={
                        <List
                          size="small"
                          split={false}
                          dataSource={importErrors.slice(0, 10)}
                          renderItem={(item) => (
                            <List.Item>
                              {t("Product")} {item.row}: {t(item.message)}
                            </List.Item>
                          )}
                        />
                      }
                    />
                  </div>
                )}
                <br />
              </li>
              <li>
                {t("Update According to")}
                <Radio.Group
                  className="mx-2 mt-3"
                  onChange={(e) => {
                    this.setState(
                      { productIdentifier: e.target.value },
                      () =>
                        this.state.rawProducts?.length > 0 &&
                        this.validateProducts(this.state.rawProducts),
                    );
                  }}
                  value={productIdentifier}
                  buttonStyle="solid"
                  size="medium"
                >
                  <Radio.Button value="id">{t("ID")}</Radio.Button>
                  <Radio.Button value="barcode">{t("Barcode")}</Radio.Button>
                  <Radio.Button value="sku">{t("SKU")}</Radio.Button>
                </Radio.Group>
              </li>
              <li className="mt-3">
                {t("Submit The File")}
                {
                  <Button
                    className="mx-2"
                    onClick={this.handleSubmit}
                    type="primary"
                    disabled={
                      this.state.products.length <= 0 ||
                      importErrors.length >= 1
                    }
                    loading={isSubmitting}
                  >
                    <SendOutlined /> {t("Submit")}
                  </Button>
                }
                <br />
                <br />
              </li>
            </ol>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(InventoryExcelUploader));
